import { DSTextInput } from '@vr/ds-react'
import { Controller } from 'react-hook-form'

import { ICollaboratorProps } from './interface'

const Collaborator = ({ control, accountKey }: ICollaboratorProps) => {
  return (
    <Controller
      key={accountKey}
      name='colaboradores'
      control={control}
      render={({ field: { onChange, value } }) => (
        <DSTextInput
          value={value}
          onChange={onChange}
          placeholder='Digite o(s) nome(s) ou CPFs do(s) colaboradore(s)'
          label='Colaborador(es)'
        />
      )}
    />
  )
}

export default Collaborator
